import React from 'react';

const Button = ({id,Author_id,type,isOutline = false,onClick,children = "Nothing yet set"}) => {

    return(
        <button
         className={(() => (
             isOutline ? "btn btn-outline-"+type.toLowerCase() : "btn btn-"+type.toLowerCase()
         ))()}
        onClick={onClick}
        id={id}>{children}</button>
    );
}

export default Button;